import { useState, useEffect, useCallback, useRef } from "react";
import { getUserPosts } from "api/community";
import useUserStore from "@store/useUserStore";
import PostMediaGrid from "components/community/PostMediaGrid";
import NoData from "components/common/NoData";
import "pages/community/community.scss";

const Feed = () => {
    const userInfo = useUserStore((state) => state.userInfo);
    const [posts, setPosts] = useState([]);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [isLoading, setIsLoading] = useState(true);
    const [isLoadingMore, setIsLoadingMore] = useState(false);
    const bottomRef = useRef(null);

    const loadPosts = useCallback(
        async (pageNum, append = false) => {
            if (!userInfo) return;
            try {
                if (append) {
                    setIsLoadingMore(true);
                } else {
                    setIsLoading(true);
                    setPosts([]);
                }
                const result = await getUserPosts(userInfo.user_id, pageNum);
                if (result.success) {
                    setPosts((prev) =>
                        append ? [...prev, ...result.data] : result.data
                    );
                    setTotalPages(result.meta?.totalPages || 0);
                }
            } catch (error) {
                console.error("내 게시글 로딩 실패:", error);
            } finally {
                setIsLoading(false);
                setIsLoadingMore(false);
            }
        },
        [userInfo]
    );

    useEffect(() => {
        setPage(1);
        loadPosts(1);
    }, [loadPosts]);

    // 무한 스크롤
    useEffect(() => {
        if (!bottomRef.current) return;
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting && !isLoadingMore && page < totalPages) {
                    const nextPage = page + 1;
                    setPage(nextPage);
                    loadPosts(nextPage, true);
                }
            },
            { threshold: 0.1 }
        );
        observer.observe(bottomRef.current);
        return () => observer.disconnect();
    }, [page, totalPages, isLoadingMore, loadPosts]);

    if (isLoading) {
        return <div className="feed-wrap" style={{ textAlign: "center", padding: "40px 0", color: "#999" }}>불러오는 중...</div>;
    }

    if (posts.length === 0) {
        return (
            <NoData
                title=""
                desc="아직 작성한 게시글이 없어요."
                btnText="글 쓰러 가기"
                btnClick={() => window.open("/community/create", "_blank")}
            />
        );
    }

    return (
        <div className="community-page community-list" style={{ paddingTop: 0 }}>
            <div className="post-list">
                <PostMediaGrid posts={posts} />
                <div ref={bottomRef} />
                {isLoadingMore && <div className="loading-more">로딩 중...</div>}
            </div>
        </div>
    );
};

export default Feed;
